<template>
  <div class="example">
    <quill-editor
      class="editor customtooltip"
      ref="myTextEditor"
      v-model="content"
      :options="editorOption"
      @change="onEditorChange"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    />
    <!-- <div class="output code">
        <code class="hljs" v-html="contentCode"></code>
      </div>
      <div class="output ql-snow">
        <div class="ql-editor" v-html="content"></div>
      </div> -->
  </div>
</template>

<script>
// import dedent from 'dedent'
import hljs from 'highlight.js'
import debounce from 'lodash/debounce'
import { quillEditor } from 'vue-quill-editor'

// highlight.js style
import 'highlight.js/styles/tomorrow.css'

// import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: 'quill-example-snow',
  title: 'Theme: snow',
  components: {
    quillEditor
  },
  data () {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video']
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value
          },
          imageResize: {
            displaySize: true,
            modules: ['Resize']
          }
        }
      }
      // content: ''
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    onEditorChange: debounce(function (value) {
      this.content = value.html
    }, 466),
    onEditorBlur (editor) {
      // this.content = editor.scrollingContainer.outerHTML
      // console.log('editor blur!', editor.scrollingContainer.outerHTML)
    },
    onEditorFocus (editor) {
      // console.log('editor focus!', editor)
    },
    onEditorReady (editor) {
      // console.log('editor ready!', editor)
    }
  },
  computed: {
    editor () {
      return this.$refs.myTextEditor.quill
    },
    contentCode () {
      return hljs.highlightAuto(this.content).value
    },
    content: {
      get () {
        return this.value
      },
      set (val) {
        // console.log('set', val)
        this.$emit('input', val)
        return val
      }
    }
  },
  created () {
    // close log
    const originalConsoleLog = console.log
    console.log = function (...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('this.options.modules')) {
        return // ปิด log ที่ไม่ต้องการ
      }
      originalConsoleLog.apply(console, args)
    }
  }
}
</script>
<style>
.customtooltip .ql-container .ql-tooltip{
  width: 98% !important;
  left: 1% !important;
  display: flex;
}

.customtooltip .ql-container .ql-tooltip.ql-hidden{
  display: none !important;
}
.customtooltip .ql-container .ql-tooltip input{
  width: 85%;
}
.ql-container.ql-snow {
  min-height: 200px;
}
</style>

<style lang="scss" scoped>
.example {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: inherit;

  .editor {
    height: inherit;
    // overflow: hidden;
    border-radius: inherit;
  }

  .output {
    width: 100%;
    height: 20rem;
    margin: 0;
    border: 1px solid #ccc;
    overflow-y: auto;
    resize: vertical;

    &.code {
      padding: 1rem;
      height: 16rem;
    }

    &.ql-snow {
      border-top: none;
      height: 24rem;
    }
  }
}
</style>
